module.exports = __webpack_public_path__ + "static/img/018.2300113e.png";